import { render, staticRenderFns } from "./fatura.vue?vue&type=template&id=23b6c5dd"
import script from "./fatura.vue?vue&type=script&lang=js"
export * from "./fatura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports